<template>
  <div class="header-container">
    <div class="d-flex align-center">
      <v-btn
          icon
          @click="$emit('toggle-drawer')"
          class="mr-4"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <span class="text-h6 font-weight-bold">
        SCM
        <span v-if="isLocal" class="text-caption primary--text ml-2">[{{isLocal}}]</span>
        <v-icon small color="primary">mdi-server</v-icon>
      </span>
    </div>

    <div class="profile-container">
      <v-select
          v-model="profile"
          :items="profiles"
          item-text="display"
          item-value="value"
          outlined
          dense
          hide-details
          @change="onChange"
      />
    </div>
  </div>
</template>


<script>
export default {
  name: "Header",
  data: () => ({
    profile: '',
    profiles: [
      {value: 'demo', display: 'DEMO'},
      // {value: 'uat', display: 'UAT'},
      // {value: 'prod', display: 'PROD'},
    ]
  }),
  computed: {
    isLocal() {
      return (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'itdev-test') ? process.env.NODE_ENV : null
    },
  },
  mounted() {
    this.profile = 'demo'
  },
  methods: {
    onChange() {
      this.$store.commit('setProfile', this.profile)
      this.$router.go(0)
    }
  }
}
</script>

<style scoped>
.header-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.profile-container {
  position: absolute;
  right: 16px;
  width: 120px;
}
</style>